import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class AccidentService extends Service {
	constructor(injector: Injector) {
		super("Accident", injector);
	}

	// API
	generatePdf(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GeneratePdf/${id}`, { responseType: "blob" as "json"} );
	}
}